import React, { useContext, useEffect, useState } from 'react'
import Modal from '../../../../common/modal/Modal'
import Button from '../../../../common/button/Button';
// import { performRequest } from '../../../../common/utils';
import { QueryClient, useQuery } from '@tanstack/react-query';
import MicroModal from 'micromodal';
import { useGroupDashboardContext } from '../../GroupDashboardContext';
import { useNavigate } from 'react-router-dom'
import { addAssignLicensesModalId } from './Utils';
import { TeamContext } from '../../MenuTabs/MenuTabs';

const AssignLicensesModal = ({
  modalOption = 'automatic',
  isAdmin = false,
  teamTitle = '',
  teamId,
  refetchAdded = null, 
  refetchInvited = null,
  navigateTo = '',
  data
}) => {

  const modalId = addAssignLicensesModalId(teamId)
  const modalIdConfirmation = modalId + '-confirmation'
  const queryClient = new QueryClient()
//   const { selectedAssignLicensesModal } = useGroupDashboardContext()
  const [ membersSelected, setMembersSelected ] = useState('')
  const [ licensesSelected, setLicensesSelected ] = useState('')
  // console.log('licensesSelected : ', licensesSelected)
  const [ membersCount, setMembersCount ] = useState(0)
  var licensesCantAssigned = []
  const [ processAssignLicenses, setProcessAssignLicenses ] = useState(false)
  const { refetchTeamData } = useContext(TeamContext);

  const [ submitAttempted, setSubmitAttempted ] = useState(false)
  const [ saveMemberResponse, setSaveMemberResponse ] = useState('')
  const [ submitOption, setSubmitOption ] = useState(modalOption)
  const [ responseTeamId, setResponseTeamId ] = useState('')
//   const [ members, setMembers ] = useState([membersArray()])
//   const isSameTeamId = parseInt( selectedAddMemberModal?.teamId ) === parseInt( responseTeamId ) ? true : false
  const navigate = useNavigate()

  // useEffect(() => {
  //   refetch()
  // }, [])

  // const { 
  //   isLoading,
  //   isFetching,
  //   isError,
  //   error,
  //   refetch,
  //   data } = useQuery({
  //     queryKey: ['msync_assign_licenses_datas'],
  //     queryFn: request,
  //     refetchOnWindowFocus: false,
  //     enabled: false
  //   }, queryClient)

  // async function request(){
  //     const currentRestUrl = window.group_dashboard.base
  //     const nonce = window.group_dashboard.nonce
  
  //     const url = currentRestUrl + 'membersync/licensing/v1/org/' + teamId + '/assign/licenses/datas'
  //   try {
  //     const res = await fetch(url, {
  //         method: 'GET',
  //         headers:{
  //           'X-WP-Nonce': nonce,
  //           'Content-type': 'application/json'
  //         }
  //     })
  //     const resultJSON = await res.json()
  //     return resultJSON.response

  //   } catch (error) {
  //     console.error( error )
  //     return false
  //   }
  // }

  tangibleFields.event('valueChange', (field, event) => {
    if( field.name === 'msync-combo-box-assign-licenses-members' ) {
      setMembersSelected( field.value )
    } else if ( field.name === 'msync-combo-box-assign-licenses-licenses' ) {
      setLicensesSelected( field.value )
    }
  })

  const handleInputColorStatus = ( isError, hasMessage ) => {
    const res = isError === true && hasMessage !== '' ? 'error' : 'default'
    return `msync-input-status-${res}`
  }

  const hasAvailableSeats = ( maxLength = 0 ) => {
    return ( 
      ! selectedAddMemberModal.seatCount 
      || selectedAddMemberModal.remainingSeats > parseInt( maxLength ) ) 
    ? true
    : false
  }

  const removeMember = ( index, formIndex ) => {
    if( ! isFormIndexEmpty( formIndex ) ){
      const result = window.confirm("Are you sure you want to remove this member form index?")
      if( ! result ) return false
    }
    const newMembers = [...members]
    newMembers.splice(index, 1)
    setMembers(newMembers)
  }

  const handleCloseModal = (modalName) => {
    MicroModal.close(modalName)
  }

  const isFormEmpty = () => {
    const hasValue = members.some(member => (
      Object.values(member).some(field => field.value)
    ))
    return !hasValue
  }

  const isFormError = () => {
    const hasError = members.some(member => (
      Object.values(member).some(field => field.error)
    ))
    return hasError
  }

  useEffect(() => {
    const selectedArray = membersSelected.split(',')
    let numberOfMembers = 0

    if ( selectedArray[0] === '' ) {
      setMembersCount( numberOfMembers )
    } else {
      selectedArray && data?.presets && selectedArray.map((element, index) => {
        numberOfMembers = element.includes( 'member' ) ? 
          numberOfMembers + 1 : 
          numberOfMembers + parseInt(data.presets[0]['member'][element]['ids'].length)
      })

      setMembersCount( numberOfMembers )
    }
  }, [membersSelected])

  const renderSelection = ( type ) => {

    const selectedArray = type === 'member' ? membersSelected.split(',') : licensesSelected.split(',')

    if ( selectedArray[0] === '' ) return ( <div></div> )
    let currentLicensesCantAssigned = []

    return (
      <div>
        {
          selectedArray.map((element, index) => {

            let content = {
              title: '',
              availability: '',
              licenses: []
            }
            if ( type === 'member' ) {
              content.title = element.includes( 'member' ) ? 
                data.members[0][element].display_name + ' ( ' + data.members[0][element].email + ' ) ' : 
                data.presets[0][type][element].name + ' (' + data.presets[0][type][element].ids.length + ')'
            } else if ( type === 'license' ) {
              if ( element.includes( 'license' ) ) {
                if ( data.licenses[0][element].seat_type ) {
                  content.title = data.licenses[0][element].title + ' ( ' + ( parseInt(data.licenses[0][element].total) - parseInt(data.licenses[0][element].assigned) ) + ' ) '
                } else {
                  content.title = data.licenses[0][element].title 
                  content.availability = data.licenses[0][element].assigned + '/' + data.licenses[0][element].total
                }
                if ( parseInt(data.licenses[0][element].assigned) + membersCount > parseInt(data.licenses[0][element].total) && !data.licenses[0][element].seat_type ) {
                  if ( !currentLicensesCantAssigned.includes(element) ) currentLicensesCantAssigned.push( element )
                } else {
                  if ( data.licenses[0][element].seat_type ) {
                    let numberOfUserWithSeats = 0
                    const membersSelectedArray = membersSelected.split(',')

                    if ( membersSelectedArray.length !== 0 ) {
                      membersSelectedArray.map((memberName) => {
                        if ( memberName.includes('member') ) {
                          if ( data.members[0][memberName].seat ) numberOfUserWithSeats += 1
                        } else {
                          (data.presets[0]['member'][memberName].ids).map((id) => {
                            let memberToSearch = 'member' + id
                            if ( data.members[0][memberToSearch].seat ) numberOfUserWithSeats += 1
                          })
                        }
                      })

                      if ( parseInt(data.licenses[0][element].assigned) + numberOfUserWithSeats > parseInt(data.licenses[0][element].total) ) {
                        if ( !currentLicensesCantAssigned.includes(element) ) currentLicensesCantAssigned.push( element )
                      }
                    }
                  }
                }
              } else {
                content.title = data.presets[0]['license'][element].name;

                (data.presets[0]['license'][element]['ids']).map((currentID) => {
                  let licenseIndex = 'license' + currentID.license_type + currentID.product_id
                  content['licenses'].push({
                    title: data.licenses[0][licenseIndex].title,
                    availability: data.licenses[0][licenseIndex].assigned + '/' + data.licenses[0][licenseIndex].total
                  } )
                  if ( parseInt(data.licenses[0][licenseIndex].assigned) + membersCount > parseInt(data.licenses[0][licenseIndex].total) && !data.licenses[0][licenseIndex].seat_type ) {
                    if ( !currentLicensesCantAssigned.includes(licenseIndex) ) currentLicensesCantAssigned.push( licenseIndex )
                  } else {
                    if ( data.licenses[0][licenseIndex].seat_type ) {
                      let numberOfUserWithSeats = 0
                      const membersSelectedArray = membersSelected.split(',')

                      if ( membersSelectedArray.length !== 0 ) {
                        membersSelectedArray.map((memberName) => {
                          if ( data.members[0][memberName].seat ) numberOfUserWithSeats += 1
                        })

                        if ( parseInt(data.licenses[0][licenseIndex].assigned) + numberOfUserWithSeats > parseInt(data.licenses[0][licenseIndex].total) ) {
                          if ( !currentLicensesCantAssigned.includes(licenseIndex) ) currentLicensesCantAssigned.push( licenseIndex )
                        }
                      }
                    }
                  }
                })
              }
            }

            return ( 
              <div className='msync-form__row msync-license-assignment-contents-border-bottom'>
                <div className={type === 'license' ? 'msync-license-assignment-user-contents msync-license-assignment-contents-bold' : 'msync-license-assignment-user-contents'}>
                  {
                    content.title
                  }
                </div>
                <div className={type === 'license' ? 'msync-license-assignment-license-availability-content msync-license-assignment-contents-bold' : 'msync-license-assignment-license-availability-content'}>
                  {
                    type === 'license' ? 
                      content.availability : 
                      ''
                  }
                </div>
                <div>
                  {
                    type === 'license' ?
                      <ul>
                        { 
                          (content.licenses).map((license) => {
                            return (
                              <li className='msync-license-assignment-license-content-li'>
                                {license.title}
                                ({license.availability} licenses used) 
                              </li>
                            )
                          }) 
                        } 
                      </ul> 
                      : ''
                  }
                </div>
              </div>
            )
          })
        }
        { type === 'license' && currentLicensesCantAssigned.length !== 0 ? setLicensesCantAssigned(currentLicensesCantAssigned) : '' }
      </div>
    )
  }

  const setLicensesCantAssigned = (newValue) => {
    licensesCantAssigned = newValue
  }

  const renderConfirmationSelection = ( type ) => {

    const selectedArray = type === 'member' ? membersSelected.split(',') : licensesSelected.split(',')

    if ( selectedArray[0] === '' ) return ( <div></div> )

    let contentsName = []
    selectedArray.map((element, index) => {
      if ( type === 'member' ) {
        if ( element.includes('member') ) {
          contentsName.push({
            'display_name'  : data.members[0][element].display_name,
            'email'         : data.members[0][element].email,
            'avatar'        : data.members[0][element].avatar
          })
        } else {
          (data.presets[0]['member'][element]['ids']).map((currentID) => {
            let memberIndex = 'member' + currentID
            contentsName.push({
              'display_name'  : data.members[0][memberIndex].display_name,
              'email'         : data.members[0][memberIndex].email,
              'avatar'        : data.members[0][memberIndex].avatar
            })
          })
        }
      } else if ( type === 'license' ) {
        if ( element.includes('license') ) {
          if ( parseInt(data.licenses[0][element].assigned) + membersCount <= parseInt(data.licenses[0][element].total) && !data.licenses[0][element].seat_type ) {
            let licenseTitle = data.licenses[0][element].title
            contentsName.push({
              title: licenseTitle,
              total: data.licenses[0][element].total,
              left: parseInt(data.licenses[0][element].total) - ( parseInt(data.licenses[0][element].assigned) + membersCount )
            })
          } else {
            if ( data.licenses[0][element].seat_type ) {
              let numberOfUserWithSeats = 0
              const membersSelectedArray = membersSelected.split(',')

              if ( membersSelectedArray.length !== 0 ) {
                membersSelectedArray.map((memberName) => {
                  if ( memberName.includes('member') ) {
                    if ( data.members[0][memberName].seat ) numberOfUserWithSeats += 1
                  } else {
                    (data.presets[0]['member'][memberName].ids).map((id) => {
                      let memberToSearch = 'member' + id
                      if ( data.members[0][memberToSearch].seat ) numberOfUserWithSeats += 1
                    })
                  }
                })

                if ( parseInt(data.licenses[0][element].assigned) + numberOfUserWithSeats <= parseInt(data.licenses[0][element].total) && numberOfUserWithSeats !== 0 ) {
                  let licenseTitle = data.licenses[0][element].title
                  contentsName.push({
                    title: licenseTitle,
                    total: data.licenses[0][element].total,
                    left: parseInt(data.licenses[0][element].total) - ( parseInt(data.licenses[0][element].assigned) + numberOfUserWithSeats )
                  })
                }
              }
            }
          }
        } else {
          (data.presets[0]['license'][element]['ids']).map((currentID) => {
            let licenseIndex = 'license' + currentID.license_type + currentID.product_id
            if ( parseInt(data.licenses[0][licenseIndex].assigned) + membersCount <= parseInt(data.licenses[0][licenseIndex].total) && !data.licenses[0][licenseIndex].seat_type ) {
              let licenseTitle = data.licenses[0][licenseIndex].title
              contentsName.push({
                title: licenseTitle,
                total: data.licenses[0][licenseIndex].total,
                left: parseInt(data.licenses[0][licenseIndex].total) - ( parseInt(data.licenses[0][licenseIndex].assigned) + membersCount )
              })
            } else {
              if ( data.licenses[0][licenseIndex].seat_type ) {
                let numberOfUserWithSeats = 0
                const membersSelectedArray = membersSelected.split(',')

                if ( membersSelectedArray.length !== 0 ) {
                  membersSelectedArray.map((memberName) => {
                    if ( memberName.includes('member') ) {
                      if ( data.members[0][memberName].seat ) numberOfUserWithSeats += 1
                    } else {
                      (data.presets[0]['member'][memberName].ids).map((id) => {
                        let memberToSearch = 'member' + id
                        if ( data.members[0][memberToSearch].seat ) numberOfUserWithSeats += 1
                      })
                    }
                  })

                  if ( parseInt(data.licenses[0][licenseIndex].assigned) + numberOfUserWithSeats <= parseInt(data.licenses[0][licenseIndex].total) && numberOfUserWithSeats !== 0 ) {
                    let licenseTitle = data.licenses[0][licenseIndex].title
                    contentsName.push({
                      title: licenseTitle,
                      total: data.licenses[0][licenseIndex].total,
                      left: parseInt(data.licenses[0][licenseIndex].total) - ( parseInt(data.licenses[0][licenseIndex].assigned) + numberOfUserWithSeats )
                    })
                  }
                }
              }
            }
          })
        }
      }
    })

    return (
      <div>
        <div>
          {
            contentsName.map((contentName) => {
              return (
                <div>
                  { type === 'license' ? 
                      <div className='msync-confirm-license-assignment-license-contents'>
                        <div className='msync-confirm-license-assignment-license-title'>
                          { contentName.title }
                        </div>
                        <div>
                          { contentName.left }/{ contentName.total } licenses will remain after action
                        </div>
                      </div> :
                      <div className='msync-confirm-license-assignment-user-contents'>
                        <div>
                          <img className='msync-small-profile-avatar' src={ contentName.avatar } alt="Member's avatar" />
                        </div>
                        <div className='msync-confirm-license-assignment-user-infos'>
                          <div className='msync-confirm-license-assignment-user-display-name'>
                            { contentName.display_name }
                          </div>
                          <div className='msync-confirm-license-assignment-user-email'>
                            { contentName.email }
                          </div>
                        </div>
                      </div>
                  }
                </div>
              )
            })
          }
        </div>          
      </div>
    )
  }

  const assignLicenses = async () => {

    const currentRestUrl = window.group_dashboard.base
    const nonce = window.group_dashboard.nonce

    const url = currentRestUrl + 'membersync/licensing/v1/org/' + teamId + '/assign/licenses'

    const licensesSelectedArray = licensesSelected.split(',')
    const membersSelectedArray = membersSelected.split(',')
    let licensesToAssign = []
    let numberOfUserWithSeats = 0

    membersSelectedArray.map((memberName, index) => {
      if ( memberName.includes('member') ) {
        if ( data.members[0][memberName].seat ) numberOfUserWithSeats += 1
        let memberId = memberName.replace( 'member', '' )
        membersSelectedArray[index] = memberId
      } else {
        (data.presets[0]['member'][memberName].ids).map((id) => {
          let memberToSearch = 'member' + id
          if ( data.members[0][memberToSearch].seat ) numberOfUserWithSeats += 1
        })
        membersSelectedArray[index] = {
          member_ids: data.presets[0]['member'][memberName].ids
        }
      }
    })

    licensesSelectedArray.map((licenseName, index) => {
      if ( licenseName.includes('license') ) {
        if ( parseInt(data.licenses[0][licenseName].assigned) + membersCount <= parseInt(data.licenses[0][licenseName].total) && !data.licenses[0][licenseName].seat_type ) {
          licensesToAssign.push({
            license_type_id: data.licenses[0][licenseName].license_type,
            product_id: data.licenses[0][licenseName].product_id,
            seat_type_id: data.licenses[0][licenseName].seat_type_id
          })
        } else if ( data.licenses[0][licenseName].seat_type && numberOfUserWithSeats !== 0 ) {
          licensesToAssign.push({
            license_type_id: data.licenses[0][licenseName].license_type,
            product_id: data.licenses[0][licenseName].product_id,
            seat_type_id: data.licenses[0][licenseName].seat_type_id
          })
        }
      } else {
        (data.presets[0]['license'][licenseName].ids).map((license_infos) => {
          let licenseIndex = 'license' + license_infos.license_type + license_infos.product_id
          if ( parseInt(data.licenses[0][licenseIndex].assigned) + membersCount <= parseInt(data.licenses[0][licenseIndex].total) && !data.licenses[0][licenseIndex].seat_type ) {
            licensesToAssign.push({
              license_type_id: license_infos.license_type_id,
              product_id: license_infos.product_id
            })
          } else if ( data.licenses[0][licenseIndex].seat_type && numberOfUserWithSeats !== 0 ) {
            licensesToAssign.push({
              license_type_id: license_infos.license_type_id,
              product_id: license_infos.product_id
            })
          }
        })
      }
    })

    try {
      const res = await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          members: membersSelectedArray,
          licenses: licensesToAssign
        }),
        headers:{
          'X-WP-Nonce': nonce,
          'Content-type': 'application/json'
        }
      })
      setProcessAssignLicenses(false)
      MicroModal.close(modalIdConfirmation)
      refetchTeamData()
    } catch (error) {
      console.error( error )
      return false
    }
  }
  
  const renderLicensesCantAssigned = () => {

    if ( licensesCantAssigned.length === 0 ) return 

    return (
      <div className='msync-insufficient-licenses'>
        <div className='msync-insufficient-licenses-title'>
          Insufficient licenses
        </div>
        <div>
          You don't have enough licenses for { licensesCantAssigned.map((license, index) => {
            return index === 0 ? data.licenses[0][license].title : ' , ' + data.licenses[0][license].title
          }) } to assign this preset / license. Continue and the license will be left out.
        </div>
      </div>
    )
  }

  const renderSeatTypesLicensesInfos = () => {
    let renderInfo = false
    let userWithoutSeat = ''

    if ( licensesSelected === '' || membersSelected === '' ) return
    
    const licensesSelectedArray = licensesSelected.split(',')
    const membersSelectedArray = membersSelected.split(',')
    
    licensesSelectedArray.map(( licenseName ) => {
      if ( data.licenses[0][licenseName].seat_type ) {
        membersSelectedArray.map(( memberName ) =>{
          if ( memberName.includes('member') ) {
            if ( !data.members[0][memberName].seat ) {
              renderInfo = true
              if ( userWithoutSeat === '' ) {
                userWithoutSeat += data.members[0][memberName].display_name
              } else {
                userWithoutSeat += ',' + data.members[0][memberName].display_name
              }
            }
          } else {
            (data.presets[0]['member'][memberName].ids).map((id) => {
              let memberToSearch = 'member' + id
              if ( !data.members[0][memberToSearch].seat ) {
                renderInfo = true
                if ( userWithoutSeat === '' ) {
                  userWithoutSeat += data.members[0][memberToSearch].display_name
                } else {
                  userWithoutSeat += ',' + data.members[0][memberToSearch].display_name
                }
              }
            })
          }
        })
      }
    })

    if ( renderInfo ) {
      return (
        <div className='msync-insufficient-licenses'>
          <div className='msync-insufficient-licenses-title'>
            Warning ! 
          </div>
          <div>
            You're trying to assign licenses that will only be assigned to members who have a seat assigned.
            Current members selected who don't have a seat : { userWithoutSeat }
          </div>
        </div>
      )
    }
  }

  useEffect(() => {
    if ( processAssignLicenses ) {
      assignLicenses()
    }
  }, [processAssignLicenses])

  return (
    <>
      <Modal 
        modalId={modalId} 
        buttonTitle="" 
        modalHeading='License Assignment'
        modalClassNames={ 'msync-assign-licenses-custom-modal msync-assign-licenses-custom-modal-border'}
      >
        <main className="msync-modal__body">
              {/* {
                isError
                ? <div className='msync-save-members-response error'><span>{ error.message }</span></div>
                : saveMemberResponse && <div className='msync-save-members-response error'><span>{ saveMemberResponse }</span></div>
              } */}
            <div className="msync-modal-content-section">
              <div key={''} className="msync-form">
                <div className="msync-form__row">
                    {/* <div className="msync-form__col"> */}
                      {/* <div className=""> */}
                        <div className="msync-form__licenses-users">
                          <span className='msync-form__users-title'>Select Users</span>
                          <div>
                            {
                              data?.selects.members && tangibleFields.render({
                                type: 'combo-box',
                                name: 'msync-combo-box-assign-licenses-members',
                                label: '',
                                multiple: true,
                                choices: data.selects.members[0].choices
                                // isAsync: true,
                                // ajaxAction: 'get_members_select_assigned_licenses',
                                // asyncArgs: {
                                //   org_id: teamId
                                // }
                              })
                            }
                          </div>
                          <div>
                            {
                              membersSelected && renderSelection( 'member' )
                            }
                          </div>
                        </div>
                        <div className="msync-form__col">
                          <span className='msync-form__users-title'>Select Licenses</span>
                          <div>
                            {
                              data?.selects.licenses && tangibleFields.render({
                                type: 'combo-box',
                                name: 'msync-combo-box-assign-licenses-licenses',
                                label: '',
                                multiple: true,
                                choices: data.selects.licenses[0].choices
                                // isAsync: true,
                                // ajaxAction: 'get_members_select_assigned_licenses',
                                // asyncArgs: {
                                //   org_id: teamId
                                // }
                              })
                            }
                          </div>
                          <div>
                            {
                              licensesSelected && renderSelection( 'license' )
                            }
                          </div>
                        </div>
                      {/* </div> */}
                    {/* </div> */}
                </div>
              </div>
              <div className="msync-form__row">
                {
                  renderLicensesCantAssigned()
                }
              </div>
              <div className="msync-form__row">
                {
                  renderSeatTypesLicensesInfos()
                }
              </div>
            </div>
          <footer className="modal__footer">
            <Button
              className="msync-button--is-style-outline msync-button--is-theme-destructive"
              type="button"
              name="Cancel"
              onClick={ () => handleCloseModal(modalId) }
              aria-label="Close this dialog window"
            />
            <Button
              className="msync-primary-btn"
              onClick={ () => {
                handleCloseModal(modalId)
                MicroModal.show(modalIdConfirmation)
              }}
              name="Assign Licenses"
            />
          </footer>
        </main>
      </Modal>
      <Modal 
        modalId={modalIdConfirmation} 
        buttonTitle="" 
        modalHeading='Confirm License Assignment'
        modalClassNames={ 'msync-assign-licenses-custom-modal msync-assign-licenses-custom-modal-border'} 
      >
        <main className="msync-modal__body">
              {/* {
                isError
                ? <div className='msync-save-members-response error'><span>{ error.message }</span></div>
                : saveMemberResponse && <div className='msync-save-members-response error'><span>{ saveMemberResponse }</span></div>
              } */}
            <div className="msync-modal-content-section">
              <div key={''} className="msync-form">
                <div className="msync-form__row">
                  <div className='msync-form__licenses-users'>
                    <span>Users</span>
                    <div>
                      {
                        membersSelected && renderConfirmationSelection( 'member' )
                      }
                    </div>
                  </div>
                  <div className='msync-form__licenses-contents'>
                    <span>Content</span>
                    <div>
                      {
                        licensesSelected && renderConfirmationSelection( 'license' )
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <footer className="modal__footer">
            <Button
              className="msync-button--is-theme-secondary msync-button--is-style-outline"
              type="button"
              name="Edit Assignment"
              onClick={ () => {
                handleCloseModal(modalIdConfirmation)
                MicroModal.show(modalId)
              }}
              isDisabled={ processAssignLicenses }
              aria-label="Close this dialog window"
            />
            <Button
              className="msync-primary-btn"
              onClick={ () => setProcessAssignLicenses(true) }
              name={processAssignLicenses ? "...Loading" : "Confirm"}
              isDisabled={ processAssignLicenses || licensesSelected === '' }
            />
          </footer>
        </main>
      </Modal>
    </>
  )
}

export default AssignLicensesModal
